// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/styles/adminMonitoring.css */

.admin-monitoring {
  padding: 20px;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.monitoring-header {
  margin-bottom: 2rem;
}

.monitoring-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 指标卡片样式 */
.metric-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  margin-bottom: 20px;
}

.metric-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
}

.metric-card .card-body {
  display: flex;
  align-items: center;
  padding: 1.5rem;
}

.metric-icon {
  font-size: 2.5rem;
  margin-right: 1rem;
  opacity: 0.9;
}

.metric-content h3 {
  margin: 0;
  font-size: 2rem;
  font-weight: bold;
}

.metric-content p {
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.9;
}

/* 状态指示器 */
.status-indicator {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
}

.status-healthy {
  background-color: #d4edda;
  color: #155724;
}

.status-unhealthy {
  background-color: #f8d7da;
  color: #721c24;
}

.status-warning {
  background-color: #fff3cd;
  color: #856404;
}

/* 图表容器 */
.chart-container {
  position: relative;
  height: 300px;
  margin: 1rem 0;
}

.chart-container canvas {
  border-radius: 8px;
}

/* 指标表格 */
.metrics-table {
  font-size: 0.9rem;
}

.metrics-table td {
  padding: 0.5rem;
  border-color: #e9ecef;
}

.metrics-table .metric-name {
  font-weight: 500;
  color: #495057;
}

.metrics-table .metric-value {
  font-family: 'Courier New', monospace;
  font-weight: bold;
}

.metric-positive {
  color: #28a745;
}

.metric-negative {
  color: #dc3545;
}

.metric-neutral {
  color: #6c757d;
}

/* 工具按钮 */
.monitoring-tools {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.monitoring-tools .btn {
  border-radius: 8px;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  transition: all 0.2s ease;
}

.monitoring-tools .btn:hover {
  transform: translateY(-2px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .admin-monitoring {
    padding: 10px;
  }
  
  .monitoring-header h2 {
    font-size: 1.5rem;
  }
  
  .monitoring-controls {
    flex-direction: column;
    gap: 5px;
  }
  
  .metric-card .card-body {
    padding: 1rem;
  }
  
  .metric-icon {
    font-size: 2rem;
  }
  
  .metric-content h3 {
    font-size: 1.5rem;
  }
  
  .monitoring-tools {
    justify-content: center;
  }
}

/* 加载动画 */
.monitoring-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #6c757d;
}

.monitoring-loading .spinner-border {
  margin-right: 10px;
}

/* 错误状态 */
.monitoring-error {
  text-align: center;
  padding: 2rem;
  color: #dc3545;
}

.monitoring-error h4 {
  margin-bottom: 1rem;
}

/* 实时更新指示器 */
.live-indicator {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.8rem;
  color: #28a745;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.live-dot {
  width: 8px;
  height: 8px;
  background-color: #28a745;
  border-radius: 50%;
}

/* 卡片阴影效果 */
.card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease;
}

.card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  border-radius: 12px 12px 0 0 !important;
  font-weight: 600;
  color: #495057;
}

/* 工具提示样式 */
.metric-tooltip {
  font-size: 0.8rem;
  color: #6c757d;
  margin-top: 5px;
}

/* 趋势指示器 */
.trend-indicator {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.8rem;
  margin-left: 8px;
}

.trend-up {
  color: #28a745;
}

.trend-down {
  color: #dc3545;
}

.trend-stable {
  color: #6c757d;
}
`, "",{"version":3,"sources":["webpack://./src/styles/adminMonitoring.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* frontend/src/styles/adminMonitoring.css */\n\n.admin-monitoring {\n  padding: 20px;\n  background-color: #f8f9fa;\n  min-height: 100vh;\n}\n\n.monitoring-header {\n  margin-bottom: 2rem;\n}\n\n.monitoring-controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* 指标卡片样式 */\n.metric-card {\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  margin-bottom: 20px;\n}\n\n.metric-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);\n}\n\n.metric-card .card-body {\n  display: flex;\n  align-items: center;\n  padding: 1.5rem;\n}\n\n.metric-icon {\n  font-size: 2.5rem;\n  margin-right: 1rem;\n  opacity: 0.9;\n}\n\n.metric-content h3 {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: bold;\n}\n\n.metric-content p {\n  margin: 0;\n  font-size: 0.9rem;\n  opacity: 0.9;\n}\n\n/* 状态指示器 */\n.status-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.status-healthy {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.status-unhealthy {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.status-warning {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n/* 图表容器 */\n.chart-container {\n  position: relative;\n  height: 300px;\n  margin: 1rem 0;\n}\n\n.chart-container canvas {\n  border-radius: 8px;\n}\n\n/* 指标表格 */\n.metrics-table {\n  font-size: 0.9rem;\n}\n\n.metrics-table td {\n  padding: 0.5rem;\n  border-color: #e9ecef;\n}\n\n.metrics-table .metric-name {\n  font-weight: 500;\n  color: #495057;\n}\n\n.metrics-table .metric-value {\n  font-family: 'Courier New', monospace;\n  font-weight: bold;\n}\n\n.metric-positive {\n  color: #28a745;\n}\n\n.metric-negative {\n  color: #dc3545;\n}\n\n.metric-neutral {\n  color: #6c757d;\n}\n\n/* 工具按钮 */\n.monitoring-tools {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.monitoring-tools .btn {\n  border-radius: 8px;\n  font-size: 0.9rem;\n  padding: 0.5rem 1rem;\n  transition: all 0.2s ease;\n}\n\n.monitoring-tools .btn:hover {\n  transform: translateY(-2px);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .admin-monitoring {\n    padding: 10px;\n  }\n  \n  .monitoring-header h2 {\n    font-size: 1.5rem;\n  }\n  \n  .monitoring-controls {\n    flex-direction: column;\n    gap: 5px;\n  }\n  \n  .metric-card .card-body {\n    padding: 1rem;\n  }\n  \n  .metric-icon {\n    font-size: 2rem;\n  }\n  \n  .metric-content h3 {\n    font-size: 1.5rem;\n  }\n  \n  .monitoring-tools {\n    justify-content: center;\n  }\n}\n\n/* 加载动画 */\n.monitoring-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  color: #6c757d;\n}\n\n.monitoring-loading .spinner-border {\n  margin-right: 10px;\n}\n\n/* 错误状态 */\n.monitoring-error {\n  text-align: center;\n  padding: 2rem;\n  color: #dc3545;\n}\n\n.monitoring-error h4 {\n  margin-bottom: 1rem;\n}\n\n/* 实时更新指示器 */\n.live-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.8rem;\n  color: #28a745;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% { opacity: 1; }\n  50% { opacity: 0.5; }\n  100% { opacity: 1; }\n}\n\n.live-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #28a745;\n  border-radius: 50%;\n}\n\n/* 卡片阴影效果 */\n.card {\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  transition: box-shadow 0.2s ease;\n}\n\n.card:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.card-header {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  border-radius: 12px 12px 0 0 !important;\n  font-weight: 600;\n  color: #495057;\n}\n\n/* 工具提示样式 */\n.metric-tooltip {\n  font-size: 0.8rem;\n  color: #6c757d;\n  margin-top: 5px;\n}\n\n/* 趋势指示器 */\n.trend-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.8rem;\n  margin-left: 8px;\n}\n\n.trend-up {\n  color: #28a745;\n}\n\n.trend-down {\n  color: #dc3545;\n}\n\n.trend-stable {\n  color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
